export const isNetworkError = error => error && error.xhr;